import React from 'react';
import './App.css';
const Info = ({ num,id, Imax, T50, Iac, date, deleteCard, showCard }) => {
  const handleDelete = () => {
    deleteCard(id);
  };

  const handleShowCard = () => {
    showCard(id);
  };
  return (
    <div className="col l4 m6 s12 info-container">
      <div className="card">
        <div className="card-content" >
          <div className="card-display"
            onClick={handleShowCard}
          >
            <span className = "card-label">
            {num+1}
            </span>
            <hr className = "card-line"></hr>
            <span className="card-title" >
              Date: {date}
            </span>
            <div className="card-data">
              <span >Imax: {Imax} A</span>
              <span >T50: {T50} us</span>
              <span >Iac: {Iac} A</span>
            </div>
          </div>


          <button className="delete-btn" onClick={handleDelete}>
            X
              </button>
        </div>
      </div>
    </div >
  );

}
export default Info;